export * from './storage-setup-template';
